jQuery(document).ready(function($) {
    if ($('body').hasClass('page-deltalive-news')) {
        var canBeLoaded = true;
        var page = parseInt(loadmorenews_params.current_page) + 1;
        var maxPage = loadmorenews_params.max_page;

        $('#load-more-button').on('click', function() {
            if (!canBeLoaded) {
                return;
            }

            console.log('Load More button clicked');
            console.log('Current page:', page);
            $.ajax({
                url: loadmorenews_params.ajaxurl,
                type: 'POST',
                data: {
                    action: 'loadmorenews',
                    page: page
                },
                beforeSend: function() {
                    console.log('Sending AJAX request');
                    canBeLoaded = false;
                    $('#load-more-button').text('Loading...');
                },
                success: function(response) {
                    if (response.success) {
                        $('#load-more-container').append(response.data.content);
                        page++;
                        canBeLoaded = true;
                        $('#load-more-button').text('Load More');
                        if (page > response.data.max_page) {
                            $('#load-more-button').remove();
                            $('#no-results').show();
                        }
                    } else {
                        console.log('No more posts to load.');
                        $('#load-more-button').remove();
                        $('#no-results').show();
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.log('AJAX request failed');
                    console.log(textStatus, errorThrown);
                }
            });
        });

        $('.filter').change(function(){
           runNewsFilters();
        });

        function runNewsFilters() {
            var topic = $('.topic-filter #topic-dropdown').val(),
                date = $('.date-filter #date-dropdown').val(),
                service = $('.service-filter #service-dropdown').val();
            $('.news-item').fadeOut().filter(function() {
                var isTopicMatch = (topic === '.' || $(this).data('news-category') === topic);
                var isDateMatch = (date === '.' || $(this).data('publish-date') === date);
                var isServiceMatch = (service === '.' || $(this).data('service-tag') === service);

                return isTopicMatch && isDateMatch && isServiceMatch;
            }).fadeIn();


        }
    }
    $('body.single-news .news-carousel .carousel-element').slick({
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 3,
        prevArrow: null,
        nextArrow: null,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '60px',
                    slidesToShow: 7
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }
            }
        ]
    });
});